import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const capitalizeFirstLetter = (string) => {
  return string.charAt(1).toUpperCase() + string.slice(2);
};

const NonAuthLayout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = capitalizeFirstLetter(pathname) + ' | Chiedimi.it - CRM';
  }, [pathname]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default NonAuthLayout;
